import {apiFetchPermission} from '../../util/MainApiFetch'

export async function readData(queries) {
    return await apiFetchPermission('/user/group_permission/current', queries, {})
}

export async function readPermission(params1, params2) {
    return await readData({feature_id: params1, access_type_id: params2})
}